var map = {
	"./bmp": 832,
	"./bmp.js": 832,
	"./gif": 833,
	"./gif.js": 833,
	"./jpg": 834,
	"./jpg.js": 834,
	"./png": 835,
	"./png.js": 835,
	"./psd": 836,
	"./psd.js": 836,
	"./svg": 837,
	"./svg.js": 837,
	"./tiff": 838,
	"./tiff.js": 838,
	"./webp": 839,
	"./webp.js": 839
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 830;


//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/types ^\.\/.*$
// module id = 830
// module chunks = 1